export default function BarChartSkeleton() {
  return (
    <div className="flex h-full w-full flex-col items-center gap-4 p-5 tablet:p-10">
      <section className="h-5 w-1/2 animate-pulse rounded-sm bg-neutral-blue-700 text-transparent tablet:h-10">
        .
      </section>
      <section className="h-3 w-2/3 animate-pulse rounded-sm bg-neutral-blue-700 text-transparent tablet:h-5">
        .
      </section>
      <div className="grid aspect-[1.5] w-full grid-cols-6 gap-x-5 align-bottom">
        <section className="h-[20%] w-full animate-pulse place-self-end rounded-sm bg-neutral-blue-700 text-transparent">
          .
        </section>
        <section className="h-[80%] w-full animate-pulse place-self-end rounded-sm bg-neutral-blue-700 text-transparent">
          .
        </section>
        <section className="h-[60%] w-full animate-pulse place-self-end rounded-sm bg-neutral-blue-700 text-transparent">
          .
        </section>
        <section className="h-[50%] w-full animate-pulse place-self-end rounded-sm bg-neutral-blue-700 text-transparent">
          .
        </section>
        <section className="h-[90%] w-full animate-pulse place-self-end rounded-sm bg-neutral-blue-700 text-transparent">
          .
        </section>
        <section className="h-[35%] w-full animate-pulse place-self-end rounded-sm bg-neutral-blue-700 text-transparent">
          .
        </section>
      </div>
    </div>
  )
}
